module.exports = __webpack_public_path__ + "img/20190523195017微信截图_20190523195357.6be8889a.png";